export default "__VITE_ASSET__Cyfb12Ok__"